var Marionette = require('marionette');
var Dropdown = require('Dropdown');
var Validation = require('validation');
var Lookups = EY.Consultation.Lookups;
var Entities = require('Entities');

var TextField = Marionette.View.extend({
    className: 'col-md-3 col-xs-11 col-sm-11  col-md-offset-1',
    events: {
        'blur @ui.text': function () { this.model.set('answer', this.ui.text.val()); }
    },
    template: '#recordCustomFieldText',
    ui: {
        text: '#text'
    },
    initialize: function () {
        Validation.bind(this);
    }
});

var DateField = Marionette.View.extend({
    className: 'col-md-3 col-xs-11 col-sm-11 col-md-offset-1',
    template: '#recordCustomFieldDate',
    ui: {
        date: '#date',
        prdate: '#prdate'
    },
    initialize: function () {
        Validation.bind(this);
    },
    onRender: function () {
        var context = this;
        this.ui.date.val(this.model.get('answer') ? new Date(this.model.get('answer')).format() : ''); 
        this.ui.prdate.html(this.model.get('answer') ? new Date(this.model.get('answer')).format() : ''); 
        this.ui.date.datepicker({
            todayHighlight: true,
            format: 'dd MM yyyy',
            autoclose: true
        }).on('changeDate',
            function (e) {
                context.model.set('answer', e.date);
            });
    }
});

var DropdownField = Marionette.View.extend({
    className: 'col-md-3 col-xs-11 col-sm-11 col-md-offset-1',
    regions: {
        dropdown: '#dropdown'
    },
    template: '#recordCustomFieldDropdown',
    initialize: function () {
        Validation.bind(this);
    },
    onRender: function () {
        var model = this.model;
        var collection = new Backbone.Collection(model.get('answer'));

        Dropdown.show({
            collection: collection,
            region: this.getRegion('dropdown'),
            onSelectionChanged: function () {
                model.set('answer', collection.toJSON());
            }
        });
    }
});

var Fields = Marionette.CollectionView.extend({
    childView: function (item) {
        var view = '';

        switch (item.get('customFieldTypeId')) {
            case Lookups.CustomFieldType.Text:
                view = TextField;
                break;
            case Lookups.CustomFieldType.Date:
                view = DateField;
                break;
            case Lookups.CustomFieldType.Dropdown:
                view = DropdownField;
                break;
        }
        return view;
    }
});

var Row = Marionette.View.extend({
    className: 'row',
    template: '#customFieldRow',
    regions: {
        fields: '#fieldRow'
    },
    onRender: function () {
        var start = this.options.index * 3;
        var collection = new Entities.CustomFields(this.options.fields.slice(start, start + 3));
        var fields = new Fields({ collection: collection });

        this.getRegion('fields').show(fields);
        fields.children.first().$el.removeClass('col-md-offset-1');
    }
});

var Layout = Marionette.CollectionView.extend({
    childView: Row,
    childViewOptions: function(model, index) {
        return {
            index: index,
            fields: this.options.fields
        };

    }
});

module.exports.start = function (options) {
    var region = options.region;
    var fields = options.fields;
    var index = 1;
    var collection = new Backbone.Collection();
    var rows = Math.ceil((fields.length / 3));

    while (index <= rows) {
        collection.add(new Backbone.Model({ row: true }));
        index++;
    }

    region.show(new Layout({
        collection: collection,
        fields: fields
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordCustomField.js